module.exports = __webpack_public_path__ + "static/media/666.56c5ebca.webp";